import React from "react";
import { Stack } from "@bookingcom/bui-react";
import useExtraProductsInfoController from "./useExtraProductsInfo.controller";
import { InconsistentCabinBaggageInfo } from "../../../../../../../ancillaries/components/ExtraProducts/components/InconsistentCabinBaggageInfo";
import { BaggageItem } from "../../../../../../../ancillaries/components/ExtraProducts/components/BaggageItem";
import FlexTicketItem from "../../../../../../../ancillaries/components/ExtraProducts/components/FlexTicketItem";
import CfarTicketItem from "../../../../../../../ancillaries/components/ExtraProducts/components/CfarTicketItem";
import InsuranceItem from "../../../../../../../ancillaries/components/ExtraProducts/components/InsuranceItem";
import { UIFlightData } from "@flights/types";

const useExtraProductsInfo = (flight: UIFlightData) => {
  const {
    header,
    subheader,
    hasData,
    ancillaries,
    showLoadingPrice,
    travellers,
    inconsistentCabinBaggageInfo,
    cabinBaggagePerTraveller,
    checkedInBaggage,
    flexTicket,
    cancelForAnyReason,
    insurance,
    extrasRef
  } = useExtraProductsInfoController(flight);

  if (!hasData || !ancillaries) return undefined;

  return {
    header,
    subheader,
    content: (
      <Stack gap={2} attributes={{ ref: extrasRef }}>
        {inconsistentCabinBaggageInfo && (
          <InconsistentCabinBaggageInfo includedProducts={inconsistentCabinBaggageInfo} ancillaries={ancillaries} />
        )}

        {cabinBaggagePerTraveller && (
          <BaggageItem
            type="cabinBaggagePerTraveller"
            product={cabinBaggagePerTraveller}
            showLoadingPrice={showLoadingPrice}
            dataTestId="extra_baggage_cabin"
          />
        )}

        {checkedInBaggage && (
          /* On flight details we only get one checked baggage option which is the cheapest one */
          <BaggageItem
            type="checkedInBaggage"
            product={checkedInBaggage}
            showLoadingPrice={showLoadingPrice}
            dataTestId="extra_baggage_checkedin"
          />
        )}

        {flexTicket && (
          <span>
            <FlexTicketItem flexibleTicket={flexTicket} showLoadingPrice={showLoadingPrice} />
          </span>
        )}

        {cancelForAnyReason && (
          <span>
            <CfarTicketItem
              cancelForAnyReason={cancelForAnyReason}
              showLoadingPrice={showLoadingPrice}
              travellers={travellers?.length}
            />
          </span>
        )}

        {insurance && <InsuranceItem travelInsurance={insurance} showLoadingPrice={showLoadingPrice} />}
      </Stack>
    )
  };
};

export default useExtraProductsInfo;
